<template>
  <ion-page class="test-modal">
    <page-modal :visible="true" bg-color="white" type="vocabularyTest" @onFinish="onFinish">
      <template #default>
        <div class="test-modal_page">
          <div class="countdown flex-column align-center">
            <img :src="getBrandImageUrl('ai_smart_reading/countdown_icon.png')" alt="" />
            <span class="countdown-time common-color"
              >00:{{ props.countdownTime > 9 ? 10 : "0" + props.countdownTime }}</span
            >
          </div>
          <div class="test-modal_content">
            <span class="test-modal_title weight-700">{{ props.currentWord?.word }}</span
            ><br />
            <span class="content-explain weight-500 mt-3 mb-3"
              >停留时间超过 10 秒，建议选择不认识</span
            >

            <ul class="list mt-3 flex-column align-center">
              <li
                v-for="i in 5"
                :key="i"
                class="list-item cursor-pointer flex-row justify-between align-center"
                :class="{
                  'green-bg': props.currentWord.showAnswer && props.currentWord.answer == i,
                  'red-bg':
                    props.currentWord.myAnswer === i &&
                    props.currentWord.myAnswer !== props.currentWord.answer,
                  'mb-3': i !== 0,
                }"
                @click="props.onSelect(i, $event)"
              >
                <span>{{ props.currentWord[`option${i}`] }}</span>
                <div class="emoji">
                  <img
                    v-if="props.currentWord.showAnswer && props.currentWord.answer == i"
                    :src="getBrandImageUrl('speed/pleased_emoji.png')"
                    alt=""
                  />
                  <img
                    v-else-if="
                      props.currentWord.myAnswer === i &&
                      props.currentWord.myAnswer !== props.currentWord.answer
                    "
                    :src="getBrandImageUrl('speed/bad_emoji.png')"
                    alt=""
                  />
                  <div v-else></div>
                </div>
              </li>
              <li
                class="list-item cursor-pointer flex-row justify-between align-center mb-5"
                :class="{
                  'red-bg':
                    props.currentWord.myAnswer === 6 &&
                    props.currentWord.myAnswer !== props.currentWord.answer,
                }"
                @click="props.onSelect(6, $event)"
              >
                <span>不认识</span>
                <div class="emoji">
                  <img
                    v-if="
                      props.currentWord.myAnswer === 6 &&
                      props.currentWord.myAnswer !== props.currentWord.answer
                    "
                    :src="getBrandImageUrl('speed/bad_emoji.png')"
                    alt=""
                  />
                  <div v-else></div>
                </div>
              </li>
            </ul>
            <div class="flex-row justify-evenly">
              <div class="text-center">
                <span :class="{ 'green-word': props.correct > 0 }">{{ props.correct }}</span
                ><br />正确
              </div>
              <div class="text-center">
                <span :class="{ 'red-word': props.wrong > 0 }">{{ props.wrong }}</span
                ><br />错误
              </div>
              <div class="text-center">
                <span :class="{ 'green-word': props.remaining > 0 }">{{ props.remaining }}</span
                >/50<br />答题进度
              </div>
            </div>
          </div>
        </div>
      </template>
    </page-modal>
  </ion-page>
</template>

<script setup lang="ts">
import { IonPage } from "@ionic/vue";
import PageModal from "@/components/PageModal.vue";
import { onMounted, defineProps, defineEmits } from "vue";
import { getBrandImageUrl } from "@/js/brandImages";

interface PropsData {
  correct: any;
  wrong: any;
  remaining: any;
  currentWord: any;
  countdownTime: any;
  onSelect: (option: number, e: any) => void;
}

const props = defineProps<PropsData>();
const emit = defineEmits(["onFinish"]);

function onFinish() {
  emit("onFinish");
}

onMounted(() => {
  console.log(props.currentWord);
});
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.test-modal {
  width: 100%;
  height: 100%;

  &_page {
    position: relative;

    .countdown {
      position: absolute;
      top: 0;
      left: 11vw;
      width: 8vw;

      .countdown-time {
        display: inline-block;
        width: 100%;
        margin-top: -2vh;
        text-align: center;
        font-size: var(--font-pure-2);
        white-space: nowrap;
      }
    }
  }

  &_content {
    text-align: center;
    width: 100%;
    height: 100%;

    .content-explain {
      display: inline-block;
      font-size: var(--font-2);
      color: var(--font-deep-gray);
    }

    .list {
      padding: 0;

      &-item {
        width: 80%;
        padding: 1.5vw 5vw;
        border-radius: 3vw;
        background-color: var(--bg-color);

        .emoji {
          height: 5vh;
          width: 5vh;
          position: relative;

          img {
            //width: 6.5vw;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
  }

  .green-bg {
    background-color: var(--light-green-bg-color);
  }

  .red-bg {
    background-color: var(--red-bg-color);
  }

  .green-word {
    color: var(--green-bg-color);
  }

  .red-word {
    color: var(--font-red-color);
  }

  &_title {
    color: var(--font-black-color);
    font-size: var(--font-5-point-5);
  }
}
</style>
